export default {
    "BTC": 8,
    "USDT": 6
}
